// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3o6K3","rootSmall":"AddTileButton_rootSmall__3AAUa"};